import React from 'react';
import './CampfireSparks.css';

/**
 * 背景にうっすらキャンプファイヤーを演出するコンポーネント。
 *
 * - 画面下中央の暖色 radial glow が flicker する
 * - ランダムな火の粉が下から上に向かって上昇する
 * - position: fixed で全ページ常時表示
 */
export default function CampfireSparks() {
  const sparks = React.useMemo(
    () =>
      Array.from({ length: 28 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 6,
        duration: 4 + Math.random() * 5,
        size: 3 + Math.random() * 4,
        drift: (Math.random() - 0.5) * 130,
      })),
    []
  );

  return (
    <div className="campfire-bg" aria-hidden="true">
      <div className="campfire-glow" />
      <div className="campfire-glow campfire-glow-secondary" />
      {sparks.map((s) => (
        <span
          key={s.id}
          className="campfire-spark"
          style={{
            left: `${s.left}%`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            '--spark-drift': `${s.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
